import {appFetch, AppFetchResponse} from "../utils/appFetch";

export interface multipleProductVariants {
    productTitle: string;
    productId: string;
    variantId: string;
    discountRate: number;
}

// export const setDiscountForAllShopProducts = async (selectedDomain: string, variants: multipleProductVariants[]): Promise<AppFetchResponse> => {
//     return appFetch({
//         endpoint: 'shop/products/discounts-all',
//         method: 'PUT',
//         headers: {
//             "Content-Type": "application/json",
//         },
//         domain: selectedDomain,
//         params: {
//             variants
//         }
//     });
// }

export const setDiscountForAllShopProducts = async (selectedDomain: string, discountValue: number, shouldOverwrite: boolean): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'shop/products/discounts-all',
        method: 'PUT',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        params: {
            discountValue,
            shouldOverwrite,
        }
    });
}